<template>
    <router-view />
</template>

<script>
export default {
    name: "Licencse",
};
</script>

<style lang="scss" scoped></style>
